<template>
  <p v-if="_readonly" class="form-control-static">
    {{get(find(_options, {value: value}), 'label', '')}}
  </p>
  <el-select v-else-if="typeof spec.items === 'function'"
             class="select-primary"
             v-model="value"
             :name="_name"
             :filterable="!!spec.search"
             :placeholder="spec.placeholder"
             :readonly="_readonly"
             :multiple="!!spec.multi"
             :remote="true"
             :remote-method="reload"
             :loading="loading"
             :value-key="spec.valueKey"
             @input="onchange"
             :style="selectStyle">
    <el-option v-for="option in _options"
               class="select-primary"
               :value="option.value"
               :label="option.label"></el-option>
  </el-select>
  <el-select v-else
             class="select-primary"
             v-model="value"
             :name="_name"
             :filterable="!!spec.search"
             :placeholder="spec.placeholder"
             :readonly="_readonly"
             :multiple="!!spec.multi"
             :value-key="spec.valueKey"
             @input="onchange"
             :style="selectStyle">
    <el-option v-for="option in _options"
               class="select-primary"
               :value="option.value"
               :label="option.label"></el-option>
  </el-select>
</template>

<script>
  import {isArray, map, find, get} from 'lodash';
  import mixin from './mixin';
  import {Select} from 'element-ui';

  export default {
    name: 'f-select',
    mixins: [mixin],
    components: {
      [Select.name]: Select,
    },
    data() {
      return {
        options: [],
        loading: false,
      };
    },
    mounted() {
      this.reload();
    },
    computed: {
      map: () => map,
      find: () => find,
      get: () => get,
      _options() {
        return map(this.options, x => typeof x === 'object' ? x : {label: x, value: x});
      },
      selectStyle() {
        return this.spec.multi ? {display: 'block'} : '';
      },
    },
    watch: {
      'spec.items'() {
        this.reload();
      },
    },
    methods: {
      onchange(val) {
        if (typeof this.spec.onchange === 'function') {
          this.spec.onchange.call(this, val, this.model, this.spec);
        }
      },
      reload(search) {
        if (isArray(this.spec.items)) {
          this.options = this.spec.items;
        } else if (typeof this.spec.items === 'function') {
          this.options = [];
          this.loading = true;
          let p = this.spec.items.call(this, this.value, this.model, this.spec, search);
          if (p && typeof p.then === 'function') {
            p.then(options => {
              this.options = options;
              this.loading = false;
            }, () => {
              this.loading = false;
            });
          } else {
            this.options = p;
            this.loading = false;
          }
        } else {
          this.options = [];
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// f-select.vue?3ba33c3e